import React from 'react';
import { FileBarChart, Download, User, Calendar, FileText } from 'lucide-react';

const ReportsSection = ({ caseData, portalType = 'individual' }) => {
  const primaryColor = portalType === 'business' ? '#1E3A8A' : '#10B981';
  return (
    <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-[#DC2626] to-[#EF4444] rounded-xl flex items-center justify-center">
          <FileBarChart className="w-7 h-7 text-white" strokeWidth={2.5} />
        </div>
        <h2 className="text-3xl font-black  style={{ color: primaryColor }}">التقارير</h2>
      </div>

      {caseData.reports && caseData.reports.length > 0 ? (
        <div className="space-y-6">
          {caseData.reports.map((report) => (
            <div 
              key={report.id}
              className="border-2 border-gray-200 rounded-xl p-6 hover:border-[#DC2626] transition-all hover:shadow-lg bg-white"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#DC2626] to-[#EF4444] rounded-xl flex items-center justify-center">
                    <FileBarChart className="w-6 h-6 text-white" strokeWidth={2.5} />
                  </div>
                  <div>
                    <h3 className="text-xl font-black text-gray-900">{report.title}</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="px-3 py-1 bg-red-100 text-red-800 rounded-full text-xs font-bold">
                        {report.type}
                      </span>
                      <span className="text-sm text-gray-500 font-semibold">• {report.reportNumber}</span>
                    </div>
                  </div>
                </div>
                {report.canDownload && (
                  <button className="px-4 py-2 bg-[#C8A870] hover:bg-[#1E3A8A] text-white rounded-lg transition-colors flex items-center gap-2 font-bold">
                    <Download className="w-4 h-4" />
                    <span>تحميل</span>
                  </button>
                )}
              </div>

              <p className="text-gray-700 mb-4 leading-relaxed">{report.summary}</p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4 border-t border-gray-100">
                <div className="flex items-center gap-3 text-gray-700">
                  <User className="w-5 h-5  style={{ color: primaryColor }}" />
                  <div>
                    <div className="text-xs text-gray-500 font-semibold">معد من</div>
                    <div className="font-bold">{report.preparedBy}</div>
                  </div>
                </div>
                
                <div className="flex items-center gap-3 text-gray-700">
                  <Calendar className="w-5 h-5  style={{ color: primaryColor }}" />
                  <div>
                    <div className="text-xs text-gray-500 font-semibold">تاريخ التقرير</div>
                    <div className="font-bold">{report.date}</div>
                  </div>
                </div>

                <div className="flex items-center gap-3 text-gray-700">
                  <FileText className="w-5 h-5  style={{ color: primaryColor }}" />
                  <div>
                    <div className="text-xs text-gray-500 font-semibold">عدد الصفحات</div>
                    <div className="font-bold">{report.pages} صفحة</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <FileBarChart className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <p className="text-lg font-bold">لا توجد تقارير متاحة</p>
        </div>
      )}
    </div>
  );
};

export default ReportsSection;